export default __webpack_public_path__ + "maps-examples-simple-map-view-1200-322986437758f5d6607d71090bed8be2.webp";